import { useState } from "react";

import { getPushPermission, requestAndRegisterPush } from "@web-app/api";
import { Icon } from "@web-app/components";

export default function PushNotificationPrompt() {
  const [permission, setPermission] = useState(getPushPermission);

  const handleEnable = async () => {
    const granted = await requestAndRegisterPush();
    setPermission(granted ? "granted" : "denied");
  };

  if (permission === "granted" || permission === null) return null;

  if (permission === "denied") {
    return (
      <div className="px-3 lg:px-4 pb-2 lg:pb-3">
        <div className="flex items-center gap-2 px-2 lg:px-3 py-1.5 lg:py-2 bg-amber-50 rounded-lg text-xs lg:text-sm text-amber-700">
          <Icon
            name="notificationBell"
            className="w-3.5 h-3.5 lg:w-4 lg:h-4 flex-shrink-0"
          />
          <span>Notifications blocked — update in browser site settings</span>
        </div>
      </div>
    );
  }

  return (
    <div className="px-3 lg:px-4 pb-2 lg:pb-3">
      <button
        onClick={handleEnable}
        className="flex items-center gap-2 w-full px-2 lg:px-3 py-1.5 lg:py-2 bg-blue-50 rounded-lg text-xs lg:text-sm text-blue-700 hover:bg-blue-100 transition-colors"
      >
        <Icon
          name="notificationBell"
          className="w-3.5 h-3.5 lg:w-4 lg:h-4 flex-shrink-0"
        />
        <span>Enable browser notifications</span>
      </button>
    </div>
  );
}
